import ActivityStreamCard from "../activity/components/ActivityStreamCard";
import { WorkItemList } from "../../store/services/timelineApiRTK";

interface WorkActivityStreamProps {
  workItems: WorkItemList[];
  workId: number;
  customerNo: number;
}

const WorkActivityStream = ({ workItems, workId, customerNo }: WorkActivityStreamProps) => {
  return (
    <ActivityStreamCard
      title="Aktiviteter"
      workItems={workItems}
      customerNo={customerNo}
      workId={workId}
      showNewActivityButton={true}
    />
  );
};

export default WorkActivityStream;